import styled from 'styled-components';
import { baseColors, TextField } from '@groupby/ui-components';
import { Button } from '@/components/button';
// A plain flex row (not MUI's 12-column Grid) so every control sits at its
// own natural width, right next to its neighbor, and align-items: center
// keeps them all vertically centered regardless of each control's own
// height — the 12-column layout reserved fixed-fraction widths for Search/
// Customize View independent of how much leadingControls content there was,
// which left large gaps and let items stretch out of vertical alignment.
//
// Wraps rather than overflowing: with the calendar's extra leading controls
// the row is wider than a laptop's content area, and the page container's
// overflow: hidden clipped the Search field's right edge — clear button
// included (S4R-11376).
export const StyledTableFilterBar = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0 1rem;
`;
export const StyledLeadingControls = styled.div `
  display: flex;
  align-items: center;
`;
// Keeps its 17.5rem wherever it fits (so the Table view's row is unchanged)
// and drops to the next line when it doesn't; shrinkable only so that, alone
// on a line narrower than 17.5rem, it still can't overflow.
export const StyledSearchFieldWrapper = styled.div `
  display: flex;
  align-items: center;
  flex: 0 1 17.5rem;
  min-width: 0;
`;
export const StyledQuickFilterItem = styled.div `
  display: flex;
  align-items: center;
`;
// Absorbs the remaining row width so Customize View stays pinned to the far
// right while Search/quick filters stay compactly grouped after leadingControls.
export const StyledSpacer = styled.div `
  flex: 1 1 auto;
`;
export const StyledDropDownLabel = styled.div `
  display: flex;
  align-items: center;
  /* The button has a fixed height, so a value long enough to wrap showed only
     its middle line — "A/B test running" read as just "test". */
  white-space: nowrap;
`;
// The "Status:"/"Tags:"/"Duration:" part of the label is bold; the value
// after it (selected option, or "All") stays regular weight.
export const StyledDropDownLabelName = styled.span `
  flex-shrink: 0;
  font-weight: 700;
  color: ${baseColors.black};
  padding-right: 4px;
`;
export const StyledDropDownValueCount = styled.div `
  width: 1.25rem;
  height: 1.25rem;
  min-width: 1.25rem;
  min-height: 1.25rem;

  margin-left: 0.25rem;

  color: white;

  border-radius: 50px;
  background: ${baseColors.blue300};

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 600;
  font-size: 0.75rem;
`;
export const StyledSearchField = styled(TextField) `
  && {
    .MuiInputBase-root {
      min-height: 2.25rem;
    }

    input {
      font-size: 0.875rem;
      height: 2.25rem;
      padding: unset;
    }

    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;
// visibility (not display: none) so this slot's width stays reserved when a
// caller shares one toolbar row across views and only some of them have
// columns to customize — keeps Search/quick filters from shifting.
export const StyledCustomizeViewSlot = styled.div `
  display: flex;
  align-items: center;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
// Bordered white pill — matches the workspace toggle and Search field so
// every control in the shared toolbar row reads as the same "chip" family.
export const StyledQuickFilterButton = styled(Button) `
  && {
    height: 2.25rem;
    padding: 0 1rem;
    border: 1px solid ${baseColors.primaryGray200};
    border-radius: 999px;
    background-color: ${baseColors.white};
    color: ${baseColors.background600};
    text-transform: none;

    svg {
      ${({ $open }) => $open && 'transform: rotate(180deg);'};

      path {
        fill: ${baseColors.primaryBlueMed400};
      }
    }

    &:hover {
      color: ${baseColors.primaryBlueDark500};
      background-color: ${baseColors.background000};

      svg {
        path {
          fill: ${baseColors.primaryBlueMed400};
        }
      }
    }
  }
`;
